import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getUsersList: function ({
    limit = 9999,
    page = 1,
    filter,
    assigned = false,
    deleteStatus = ['deleteStatus[]=1']
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`, 'sort[]=username']
    if (filter) fullRequest.push(filter)
    if (assigned) fullRequest.push(`assigned=${assigned}`)
    if (deleteStatus.length) fullRequest.push(...deleteStatus)
    const withElastic = 'users?'
    const withoutElastic = 'users/withoutelastic?'
    const api = /search/.test(filter) ? withElastic : withoutElastic
    return instCred.get(api + fullRequest.join('&'))
  },
  createUser: function (user) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      },
      withCredentials: true
    })
    return instCred.post('user', user)
  },
  editUser: function (user) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      },
      withCredentials: true
    })
    return instCred.put('users/' + user.id, user)
  },
  deleteUser: function (user) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      },
      withCredentials: true
    })
    return instCred.delete('users/' + user)
  },
  checkEmail: function (email) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('user/checkemail?email=' + email)
  },
  getUser (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('users/' + id)
  },
  getSelectUser  () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('user/getSelect')
  }
}



// WEBPACK FOOTER //
// ./src/api/UsersList/api.js